import cx from 'classnames'
import PropTypes from 'prop-types'

import './Typography.scss'

// Mapa variant textových prvků
// Podle: https://www.figma.com/file/mfbDFBKTSP9EXp1nDDe5qs/%E2%AD%90%EF%B8%8F-CineStar-Design-system?node-id=1%3A32&t=xH59UkJ78wcgXrd5-0
const variantsMapping = {
    buttonPrimary: 'span',
    buttonSecondary: 'span',
    buttonSmall: 'span',
    buttonSocial: 'span',
    linkDefault: 'span',
    linkDefaultActive: 'span',
    linkSmall: 'span',
    linkSmallActive: 'span',
    formLabel: 'span',
    formText: 'span',
    formDescription: 'span',
    tableLabel: 'span',
    tableText: 'span',
    tableTextBold: 'span',
    badge: 'span',
    label: 'span',
    labelBold: 'span',
    desc: 'span',
    heroLarge: 'h1',
    hero: 'h2',
    sectionHeadline: 'h4',
    labelHeadline: 'span',
    body: 'span',
    bodyBold: 'strong',
    containerXlHeadline: 'h2',
    containerXlBody: 'span',
    containerLHeadline: 'h3',
    containerLBody: 'span',
    containerMHeadline: 'h5',
    containerMBody: 'span',
    containerSHeadline: 'h6',
    containerSBody: 'span',
    h1: 'h1',
    h2: 'h2',
    h3: 'h3',
    h4: 'h4',
    h5: 'h5',
    h6: 'h6',
    subtitle: 'h3',
    p: 'p',
    pBold: 'p',
    pLink: 'p',
    span: 'span',
}

const Typography = ({ variant, color = 'primary', children, className, ...props }) => {
    const Component = variant ? variantsMapping[variant] : 'span'

    return (
        <Component
            className={cx(
                {
                    [`typography-variant--${variant}`]: variant,
                    [`typography-color--${color}`]: color,
                },
                'm-0',
                className
            )}
            {...props}
        >
            {children}
        </Component>
    )
}

export default Typography

Typography.propTypes = {
    /*
     *   Varianta textu - dle variantsMapping
     */
    variant: PropTypes.string,
    /*
     *  Barva textu
     */
    color: PropTypes.oneOf([
        'primary',
        'secondary',
        'error',
        'warning',
        'success',
        'basePrimary',
        'darkerPrimary',
        'lighterPrimary',
        'purpleSecondary',
        'magentaSecondary',
        'magentaLighterSecondary',
        'whiteTransparent',
        'blackTransparent',
    ]),
    /*
     *  Obsah komponenty - text apod.
     */
    children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
}
